var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLike48Line = function SvgIconLike48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 20.19a5.297 5.297 0 0 0-4.06-1.89h-4.63l.63-2.31a5.25 5.25 0 0 0-.9-4.61 5.271 5.271 0 0 0-4.21-2.08h-.58c-1.05 0-2.02.57-2.54 1.49L17 18.3h-4.8c-1.6 0-2.9 1.3-2.9 2.9v13.6c0 1.6 1.3 2.9 2.9 2.9h5.52l2.55.85c.3.1.61.15.92.15h10.48a5.29 5.29 0 0 0 5.22-4.38l1.73-9.8c.27-1.55-.15-3.12-1.16-4.33ZM12.7 21.7h3.6v12.6h-3.6V21.7Zm22.57 2.23-1.73 9.8c-.16.91-.95 1.57-1.87 1.57H21.28l-1.58-.53V20.44L24 12.7h.29c.6 0 1.15.27 1.51.75.36.47.48 1.08.32 1.65l-1.8 6.6h9.08c.57 0 1.09.24 1.46.68.37.44.51.99.42 1.55h-.01Z",
    fill: "current"
  })));
};
export default SvgIconLike48Line;